let LOCALE;
let TRANSLATION_JSON;

export const STR_KEY = {};

STR_KEY.STATUS = 'status';

STR_KEY.MISC                          = 'misc';
STR_KEY.MISC_TO                       = 'misc.to';
STR_KEY.MISC_FROM                     = 'misc.from';
STR_KEY.MISC_UNTIL                    = 'misc.until';
STR_KEY.MISC_SESSIONS                 = 'misc.sessions';
STR_KEY.MISC_VARIOUS_TIMES            = 'misc.various_times';
STR_KEY.MISC_GUESTS                   = 'misc.guests';
STR_KEY.MISC_POWERED_BY               = 'misc.powered_by';
STR_KEY.MISC_ABOUT_EVENT              = 'misc.about_event';
STR_KEY.MISC_VENUE                    = 'misc.venue';
STR_KEY.MISC_ONLINE                   = 'misc.online';
STR_KEY.MISC_EVENT                    = 'misc.event';
STR_KEY.MISC_SESSION                  = 'misc.session';
STR_KEY.MISC_VENUE_EVENT              = 'misc.venue_event';
STR_KEY.MISC_VENUE_SESSION            = 'misc.venue_session';
STR_KEY.MISC_ONLINE_EVENT             = 'misc.online_event';
STR_KEY.MISC_ONLINE_SESSION           = 'misc.online_session';
STR_KEY.MISC_VENUE_AND_ONLINE_EVENT   = 'misc.venue_and_online_event';
STR_KEY.MISC_VENUE_AND_ONLINE_SESSION = 'misc.venue_and_online_session';
STR_KEY.MISC_NAME                     = 'misc.name';
STR_KEY.MISC_EMAIL                    = 'misc.email';

STR_KEY.BTN_GUESTS        = 'btn.guests';
STR_KEY.BTN_CANCEL        = 'btn.cancel';
STR_KEY.BTN_CALENDAR      = 'btn.calendar';
STR_KEY.BTN_WALLET        = 'btn.wallet';
STR_KEY.BTN_ALL_EVENTS    = 'btn.all_events';
STR_KEY.BTN_PRINT         = 'btn.print';
STR_KEY.BTN_BOOK_SESSIONS = 'btn.book_sessions';
STR_KEY.BTN_EXPAND        = 'btn.expand';
STR_KEY.BTN_COLLAPSE      = 'btn.collapse';

STR_KEY.PROFILE                              = 'profile';
STR_KEY.PROFILE_GUEST                        = 'profile.guest';
STR_KEY.PROFILE_GUESTS                       = 'profile.guests';
STR_KEY.PROFILE_DIALOG_GUEST_CHANGE          = 'profile.dialog_guest_change';
STR_KEY.PROFILE_TOAST_GUEST_CHANGE           = 'profile.toast_guest_change';
STR_KEY.PROFILE_TOAST_CHECKED_IN             = 'profile.toast_checked_in';
STR_KEY.PROFILE_BTN_ONLINE_CHECK_IN          = 'profile.btn_online_checkin';
STR_KEY.PROFILE_BTN_VENUE_CHECK_IN           = 'profile.btn_venue_checkin';
STR_KEY.PROFILE_ALERT_CHECKED_IN             = 'profile.alert_checked_in';
STR_KEY.PROFILE_ALERT_ONLINE_CHECK_IN_FROM   = 'profile.alert_online_check_in_from';
STR_KEY.PROFILE_ALERT_VENUE_CHECK_IN_FROM    = 'profile.alert_venue_check_in_from';
STR_KEY.PROFILE_ALERT_ENDED                  = 'profile.alert_ended';
STR_KEY.PROFILE_ALERT_CLOSED                 = 'profile.alert_closed';
STR_KEY.PROFILE_ALERT_WAITLISTED             = 'profile.alert_waitlisted';
STR_KEY.PROFILE_ALERT_CANCELLED              = 'profile.alert_cancelled';
STR_KEY.PROFILE_ALERT_DID_NOT_ATTEND         = 'profile.alert_did_not_attend';
STR_KEY.PROFILE_ALERT_REMOVED                = 'profile.alert_removed';
STR_KEY.PROFILE_ALERT_FULL                   = 'profile.alert_full';
STR_KEY.PROFILE_SESSION_ALERT_ENDED          = 'profile.session_alert_ended';
STR_KEY.PROFILE_SESSION_ALERT_CLOSED         = 'profile.session_alert_closed';
STR_KEY.PROFILE_SESSION_ALERT_WAITLISTED     = 'profile.session_alert_waitlisted';
STR_KEY.PROFILE_SESSION_ALERT_CANCELLED      = 'profile.session_alert_cancelled';
STR_KEY.PROFILE_SESSION_ALERT_DID_NOT_ATTEND = 'profile.session_alert_did_not_attend';
STR_KEY.PROFILE_SESSION_ALERT_REMOVED        = 'profile.session_alert_removed';
STR_KEY.PROFILE_SESSION_ALERT_FULL           = 'profile.session_alert_full';
STR_KEY.PROFILE_BTN_VIEW_TICKET              = 'profile.btn_view_ticket';

STR_KEY.SESSIONS_LIST               = 'sessions_list';
STR_KEY.SESSIONS_LIST_FALLBACK      = 'sessions_list.fallback';
STR_KEY.SESSIONS_LIST_PAST_SESSIONS = 'sessions_list.past_sessions';
STR_KEY.SESSIONS_LIST_VIEW_INFO     = 'sessions_list.view_info';

STR_KEY.CONTROLS                  = 'controls';
STR_KEY.CONTROLS_ALERT_INVITE     = 'controls.alert_invite';
STR_KEY.CONTROLS_ALERT_WAITLIST   = 'controls.alert_waitlist';
STR_KEY.CONTROLS_BTN_INVITE_YES   = 'controls.btn_invite_yes';
STR_KEY.CONTROLS_BTN_INVITE_NO    = 'controls.btn_invite_no';
STR_KEY.CONTROLS_BTN_WAITLIST_YES = 'controls.btn_waitlist_yes';
STR_KEY.CONTROLS_BTN_WAITLIST_NO  = 'controls.btn_waitlist_no';
STR_KEY.CONTROLS_DIALOG_REGISTER  = 'controls.dialog_register';
STR_KEY.CONTROLS_DIALOG_CANCEL    = 'controls.dialog_cancel';
STR_KEY.CONTROLS_TOAST_REGISTER   = 'controls.toast_register';
STR_KEY.CONTROLS_TOAST_CANCEL     = 'controls.toast_cancel';

STR_KEY.MODAL_CANCEL         = 'modal_cancel';
STR_KEY.MODAL_CANCEL_CONTENT = 'modal_cancel.content';
STR_KEY.MODAL_CANCEL_BTN_YES = 'modal_cancel.btn_yes';
STR_KEY.MODAL_CANCEL_BTN_NO  = 'modal_cancel.btn_no';
STR_KEY.MODAL_CANCEL_TOAST   = 'modal_cancel.toast';

STR_KEY.MODAL_SESSION                      = 'modal_session';
STR_KEY.MODAL_SESSION_TITLE_ABOUT          = 'modal_session.title_about';
STR_KEY.MODAL_SESSION_TITLE_HOST           = 'modal_session.title_host';
STR_KEY.MODAL_SESSION_TITLE_HOSTS          = 'modal_session.title_hosts';
STR_KEY.MODAL_SESSION_TITLE_DIRECTIONS     = 'modal_session.title_directions';
STR_KEY.MODAL_SESSION_TITLE_REGISTER       = 'modal_session.title_register';
STR_KEY.MODAL_SESSION_TITLE_CHANGE         = 'modal_session.title_change';
STR_KEY.MODAL_SESSION_BTN_YES              = 'modal_session.btn_yes';
STR_KEY.MODAL_SESSION_BTN_CHANGE           = 'modal_session.btn_change'
STR_KEY.MODAL_SESSION_BTN_NO               = 'modal_session.btn_no';
STR_KEY.MODAL_SESSION_BTN_CANCEL           = 'modal_session.btn_cancel';
STR_KEY.MODAL_SESSION_BTN_REMOVE           = 'modal_session.btn_remove';
STR_KEY.MODAL_SESSION_BTN_ACCEPT           = 'modal_session.btn_accept';
STR_KEY.MODAL_SESSION_BTN_REGISTER         = 'modal_session.btn_register';
STR_KEY.MODAL_SESSION_ALERT_CLOSED         = 'modal_session.alert_closed';
STR_KEY.MODAL_SESSION_ALERT_TIMES_FALLBACK = 'modal_session.alert_times_fallback';
STR_KEY.MODAL_SESSION_ALERT_TIMES_CLASH    = 'modal_session.alert_times_clash';
STR_KEY.MODAL_SESSION_ALERT_ACCEPT         = 'modal_session.alert_accept';
STR_KEY.MODAL_SESSION_ALERT_REGISTER       = 'modal_session.alert_register';
STR_KEY.MODAL_SESSION_ALERT_CHANGE         = 'modal_session.alert_change';
STR_KEY.MODAL_SESSION_ALERT_WAITLIST       = 'modal_session.alert_waitlist';
STR_KEY.MODAL_SESSION_TOAST_REGISTERED     = 'modal_session.toast_registered';
STR_KEY.MODAL_SESSION_TOAST_CHECKED_IN     = 'modal_session.toast_checked_in';
STR_KEY.MODAL_SESSION_TOAST_UPDATED        = 'modal_session.toast_updated';
STR_KEY.MODAL_SESSION_TOAST_CANCELLED      = 'modal_session.toast_cancelled';
STR_KEY.MODAL_SESSION_LOCATION             = 'modal_session.session_location';

STR_KEY.MODAL_WEBINAR                 = 'modal_webinar';
STR_KEY.MODAL_WEBINAR_TITLE           = 'modal_webinar.title';
STR_KEY.MODAL_WEBINAR_CONTENT_DEFAULT = 'modal_webinar.content_default';
STR_KEY.MODAL_WEBINAR_BTN_YES         = 'modal_webinar.btn_yes';
STR_KEY.MODAL_WEBINAR_BTN_NO          = 'modal_webinar.btn_no';

STR_KEY.MODAL_BOOK_SESSION                    = 'modal_book_session';
STR_KEY.MODAL_BOOK_SESSION_FALLBACK           = 'modal_book_session.fallback';
STR_KEY.MODAL_BOOK_SESSION_SEARCH_PLACEHOLDER = 'modal_book_session.search_placeholder';

STR_KEY.MODAL_GUESTS         = 'modal_guests';
STR_KEY.MODAL_GUESTS_TITLE   = 'modal_guests.title';
STR_KEY.MODAL_GUESTS_BTN_YES = 'modal_guests.btn_yes';
STR_KEY.MODAL_GUESTS_BTN_NO  = 'modal_guests.btn_no';

STR_KEY.EVENTS_PAGE_TITLE_ACTIVE   = 'events_page.title_active';
STR_KEY.EVENTS_PAGE_TITLE_PAST     = 'events_page.title_past';
STR_KEY.EVENTS_PAGE_COL_TITLE      = 'events_page.col_title';
STR_KEY.EVENTS_PAGE_COL_START_DATE = 'events_page.col_start_date';
STR_KEY.EVENTS_PAGE_COL_END_DATE   = 'events_page.col_end_date';
STR_KEY.EVENTS_PAGE_BTN_INFO       = 'events_page.btn_info';
STR_KEY.EVENTS_PAGE_TABLE_FALLBACK = 'events_page.table_fallback';

STR_KEY.CHAT_DESCRIPTION_START           = 'chat.description_start';
STR_KEY.CHAT_BTN_START                   = 'chat.btn_start';
STR_KEY.CHAT_TAB_TITLE_CHAT              = 'chat.tab_title_chat';
STR_KEY.CHAT_TAB_TITLE_ATTENDEES         = 'chat.tab_title_attendees';
STR_KEY.CHAT_TEXTAREA_PLACEHOLDER        = 'chat.textarea_placeholder';
STR_KEY.CHAT_JOIN_ANONYMOUSLY            = 'chat.join_anonymously';
STR_KEY.CHAT_ENTER_NAME_ALERT            = 'chat.enter_name_alert';
STR_KEY.CHAT_USERNAME_DESCRIPTION        = 'chat.username_description';
STR_KEY.CHAT_CONTACT_INFO_ACCESS_MESSAGE = 'chat.contact_info_access_message';

STR_KEY.VIDEO_HEADER_BTN_LEAVE            = 'video_header.btn_leave';
STR_KEY.VIDEO_HEADER_DESCRIPTION_TIME     = 'video_header.description_time';
STR_KEY.VIDEO_HEADER_DESCRIPTION_FINISHED = 'video_header.description_finished';

STR_KEY.VIDEO_PLAYER_IDLE_HEADER_STARTED          = 'video_player.idle_header_started';
STR_KEY.VIDEO_PLAYER_IDLE_HEADER_NOT_STARTED      = 'video_player.idle_header_not_started';
STR_KEY.VIDEO_PLAYER_IDLE_DESCRIPTION_STARTED     = 'video_player.idle_description_started';
STR_KEY.VIDEO_PLAYER_IDLE_DESCRIPTION_NOT_STARTED = 'video_player.idle_description_not_started';
STR_KEY.VIDEO_PLAYER_PERMISSION_BTN_YES           = 'video_player.permission_btn_yes';
STR_KEY.VIDEO_PLAYER_PERMISSION_BTN_NO            = 'video_player.permission_btn_no';

STR_KEY.VIDEO_DESCRIPTION_TITLE_ABOUT = 'video_description.title_about';
STR_KEY.VIDEO_DESCRIPTION_TITLE_HOSTS = 'video_description.title_hosts';

STR_KEY.VIDEO_SESSIONS_TITLE    = 'video_sessions.title';
STR_KEY.VIDEO_SESSIONS_BTN_OPEN = 'video_sessions.btn_open';
STR_KEY.VIDEO_SESSIONS_BTN_JOIN = 'video_sessions.btn_join';

STR_KEY.VIDEO_ADMIN_CONTROL_REPLY_TO_MESSAGE  = 'video_admin_control.reply_to_message';
STR_KEY.VIDEO_ADMIN_CONTROL_HIGHLIGHT_HOST    = 'video_admin_control.highlight_host';
STR_KEY.VIDEO_ADMIN_CONTROL_HIGHLIGHT_MESSAGE = 'video_admin_control.highlight_message';
STR_KEY.VIDEO_ADMIN_CONTROL_REMOVE_MESSAGE    = 'video_admin_control.remove_message';
STR_KEY.VIDEO_ADMIN_CONTROL_CONTACT_DETAILS   = 'video_admin_control.contact_details';
STR_KEY.VIDEO_ADMIN_CONTROL_REMOVE_ATTENDEE   = 'video_admin_control.remove_attendee';

STR_KEY.CHAT_ADMIN_CONTROL_MODAL                        = 'chat_admin_control_modal';
STR_KEY.CHAT_ADMIN_CONTROL_MODAL_CONTACT_DETAILS_TITLE  = 'chat_admin_control_modal.contact_details_title';
STR_KEY.CHAT_ADMIN_CONTROL_MODAL_REMOVE_ATTENDEE_TITLE  = 'chat_admin_control_modal.remove_attendee_title';

const ALLOWED_LOCALES = [
    'ca',
    'cy',
    'de',
    'en',
    'es',
    'zh-cn'
];

export const getLocale = () => LOCALE || 'en';

export const initTranslation = (key) => {
    // Only load once
    if (TRANSLATION_JSON) return Promise.resolve();
    // Set locale (for ref) + fallback to English when value is funky
    LOCALE = ALLOWED_LOCALES.includes(key) ? key : 'en';

    return new Promise((resolve, reject) => {
        return fetch(`/translations/${getLocale()}.json`).then(res => { 
            return res.json().then(json => {
                TRANSLATION_JSON = json;
                resolve();
            }).catch((err) => console.log('Translation Error: ' + err));
        });
    });
};

export const __ = (key, fallback = '') => {
    // Return key if translation data is not found
    if (!TRANSLATION_JSON) return fallback || key;

    const string = String(key).split('.').reduce((obj, part) => obj[part], TRANSLATION_JSON);
    return typeof string === 'string' ? string : ''; 
};

export default __;